import { APP_PDC_URL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const serviceSubscriptionConstants = {
  FETCH_SERVICES_SUBSCRIPTION_START: "FETCH_SERVICES_SUBSCRIPTION_START",
  FETCH_SERVICES_SUBSCRIPTION_ERROR: "FETCH_SERVICES_SUBSCRIPTION_ERROR",
  FETCH_SERVICES_SUBSCRIPTION_SUCCESS: "FETCH_SERVICES_SUBSCRIPTION_SUCCESS",

  FETCH_ACTIVE_ACCOUNTANT_SERVICE_START: "FETCH_ACTIVE_ACCOUNTANT_SERVICE_START",
  FETCH_ACTIVE_ACCOUNTANT_SERVICE_ERROR: "FETCH_ACTIVE_ACCOUNTANT_SERVICE_ERROR",
  FETCH_ACTIVE_ACCOUNTANT_SERVICE_SUCCESS: "FETCH_ACTIVE_ACCOUNTANT_SERVICE_SUCCESS",

  ALL_SERVICES_SUBSCRIPTION_START: "ALL_SERVICES_SUBSCRIPTION_START",
  ALL_SERVICES_SUBSCRIPTION_ERROR: "ALL_SERVICES_SUBSCRIPTION_ERROR",
  ALL_SERVICES_SUBSCRIPTION_SUCCESS: "ALL_SERVICES_SUBSCRIPTION_SUCCESS"
};

export function fetchAgyoServicesSubscription(
  auth, accountantId, clientIdSelected
) {
  let url = `${APP_PDC_URL}/subscription/services?accountantId=${accountantId}&companyId=${clientIdSelected}`;

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_START
      });

      let request = {
        method: "get",
        url: url,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200 && result.data !== "") {
            dispatch({
              type: serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_ERROR,
              error: {
                code: result.status,
                message: "Errore nel recuperare i servizi attivi in Digital"
              }
            });
          }
          resolve(result.data);
        })
        .catch((e) => {
          dispatch({
            type: serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_ERROR,
            error: {
              code: e,
              message: "Si è verificato un errore"
            }
          });
          reject();
        });
    });
  };
}

export function fetchActiveAccountantService(auth, accountantId) {
  let url = `${APP_PDC_URL}/subscription/services?accountantId=${accountantId}`;

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_START
      });

      let request = {
        method: "get",
        url: url,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200 && result.data !== "") {
            dispatch({
              type: serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_ERROR,
              error: {
                code: result.status,
                message: "Errore nel recuperare i servizi attivi in Ditigal dello studio"
              }
            });
          }
          resolve(result.data);
        })
        .catch((e) => {
          dispatch({
            type: serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_ERROR,
            error: {
              code: e,
              message: "Si è verificato un errore"
            }
          });
          reject();
        });
    });
  };
}

export function allAgyoServicesSubscription(auth) {
  let url = `${APP_PDC_URL}/subscription/services`;

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_START
      });

      let request = {
        method: "get",
        url: url,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200 && result.data !== "") {
            dispatch({
              type: serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_ERROR,
              error: {
                code: result.status,
                message: "Errore nel recuperare i servizi in Digital"
              }
            });
          }
          resolve(result.data);
        })
        .catch((e) => {
          dispatch({
            type: serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_ERROR,
            error: {
              code: e,
              message: "Si è verificato un errore"
            }
          });
          reject();
        });
    });
  };
}
